import { ITabletLocation } from "api/types";
import Button from "components/common/Button/Button";
import IconicField from "components/common/IconicField";
import PhoneNumberInput from "components/common/PhoneNumberInput/PhoneNumberInput";
import PinInput from "components/common/PinInput";
import Text from "components/common/Text/Text";
import Widget from "components/common/Widget";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import VendorLogo from "screens/Onboarding/WelcomeBoard/VendorLogo/VendorLogo";
import styled from "styled-components";
import { formatPhoneNumber } from "utils/format";

const InputContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
  margin-top: 3rem;
`;

const WidgetWrapper = styled(Widget)`
  height: 100%;
  padding: 7vh;
`;

const Label = styled.p`
  margin-top: 10px;
  margin-bottom: 5px;
`;

interface IProps {
  step: number;
  currentControl: string;
  signIn?: boolean;
  signUp?: boolean;
  phone?: string;
  checkingPhone?: boolean;
  checkingPin?: boolean;
  goodSignInPin?: boolean;
  wrongSignInPin?: boolean;
  pinReset?: boolean;
  message?: string;
  location?: ITabletLocation;
  pinGen?: string;
  onFocus(component: string): void;
  nextStep(): void;
  sendNewPin(): void;
}

const DispensaryContainer = ({
  step,
  currentControl,
  signIn,
  signUp,
  phone,
  checkingPhone,
  checkingPin,
  goodSignInPin,
  wrongSignInPin,
  pinReset,
  message,
  location,
  pinGen,
  onFocus,
  sendNewPin,
  nextStep
}: IProps) => (
  <WidgetWrapper transparent>
    <Row justify="center" onClick={onFocus("phone")}>
      <Col>
        {location && (
          <VendorLogo
            locationName={location.name}
            vendorId={location.vendorId}
          />
        )}
        <br />
        <Text h4 center fullWidth style={{ padding: 0, margin: 0 }}>
          Loyalty Rewards
        </Text>
        <InputContainer>
          <PhoneNumberInput
            value={formatPhoneNumber(phone || "")}
            fullWidth
            largeText
            readOnly
            focused={currentControl === "phone"}
          />
          <IconicField loading={checkingPhone} small />
        </InputContainer>
      </Col>
    </Row>
    {signUp ? (
      <Row justify="center" onFocus={onFocus("pin")}>
        <Col>
          <Label>Please choose a PIN (Optional)</Label>
          <PinInput pin={pinGen} small />
        </Col>
      </Row>
    ) : null}
    {signIn ? (
      <Row justify="center" onFocus={onFocus("pin")}>
        <Col>
          <Label>Enter PIN</Label>
          <PinInput
            pin={pinGen}
            goodPin={goodSignInPin}
            wrongPin={wrongSignInPin}
            loading={checkingPin}
            onClick={onFocus("pin")}
            focused={currentControl === "pin"}
            small
          />
          {pinReset ? (
            <Label>Your new PIN has been sent to your phone number.</Label>
          ) : (
            <Label onClick={sendNewPin}>
              I forgot my PIN, send me a new one by text message
            </Label>
          )}
        </Col>
      </Row>
    ) : null}
    {signUp ? (
      <Button primary onClick={nextStep} style={{ marginTop: "0.5rem" }}>
        Sign Up
      </Button>
    ) : null}
    {message && <Label>{message}</Label>}
  </WidgetWrapper>
);

export default DispensaryContainer;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/WelcomeBoard/DispensaryContainer/DispensaryContainer.tsx